import { IClient } from './../models/Client.model';
export interface IAdresse {
  id?: number;
  libelle?: string;
  region?: string;
  ville?: string;
  etat?: boolean;
  encours?: boolean;
  client?: IClient;
}

export class Adresse implements IAdresse {
  constructor(
    public id?: number,
    public libelle?: string,
    public ville?: string,
    public region?: string,
    public etat?: boolean,
    public encours?: boolean,
    public client?: IClient
  ) {
    this.etat = this.etat || false;
    this.encours = this.encours || false;
  }
}
